function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#000;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.78,232.14c11.26-13,55.63-79.86,70.63-127.47A75.42,75.42,0,1,0,4.28,94.16l0,0c.11.51.24,1,.36,1.53s.3,1.21.46,1.81C17.49,145.25,65.94,218.47,77.78,232.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.78,232.14l1.89,1.64c1.48-1.72,3.43-4.22,5.78-7.42a594.7,594.7,0,0,0,33.81-53c12.63-22.18,24.87-46.78,31.53-67.91l-2.38-.75,2.34.88A77.91,77.91,0,1,0,0,77.91,78.57,78.57,0,0,0,1.83,94.69l2.45-.53,1.46-2h0L.33,88.22l1.49,6.49c.12.52.25,1,.37,1.55h0c.15.62.31,1.24.48,1.88v0c3.17,12.17,8.57,25.81,15.09,39.7a581.38,581.38,0,0,0,33,59.64c5.47,8.73,10.61,16.48,15,22.71s7.87,10.92,10.2,13.62L77.78,236l1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.58a603.91,603.91,0,0,1-35.63-56.46c-6.54-11.72-12.88-24-18.24-35.89A218.36,218.36,0,0,1,7.5,96.85v0c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1-.36-1.5l-2.43.56-1.47,2h0L8.12,100l-1.4-6.4a72.9,72.9,0,1,1,139.35,10.16l0,.06,0,.08c-7.38,23.46-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.15,31.92-3,4.4-5.68,8.24-8,11.37s-4.2,5.57-5.53,7.1l1.89,1.64,1.89-1.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M77.74,35.73a31.54,31.54,0,1,0,31.54,31.54A31.54,31.54,0,0,0,77.74,35.73Zm-1.59,16A14.17,14.17,0,0,0,62,65.89a2.7,2.7,0,1,1-5.39,0A19.56,19.56,0,0,1,76.15,46.35a2.7,2.7,0,0,1,0,5.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M85.5,102.72a38.72,38.72,0,0,1-15.77,0v37.67l8,7.72,7.78-7.72S85.46,105.91,85.5,102.72Z"
})));

var SvgBookmarkIcon = function SvgBookmarkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark-icon.fd59f395.svg";
export { ForwardRef as ReactComponent };